module.exports = __webpack_public_path__ + "static/media/Rai.a95e694d.png";